export default __webpack_public_path__ + "static/media/gura-giga-novels2.026ac269.png";